// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3eJdg","footer":"ModalError_footer__1HCBI"};